import React from 'react';
// Import directly from the file instead of using named exports
import PracticeTestComponent from './practiceTest/PracticeTest';

/**
 * This is a wrapper component for backward compatibility
 * It simply passes all props to the new modular PracticeTest component
 */
const PracticeTest = (props) => {
  return <PracticeTestComponent {...props} />;
};

export default PracticeTest;